import * as yup from 'yup';

export const addAreasValidation = yup.object().shape({
    name: yup.string().required(),
});
